
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/geo",
      function () {
        return require("private-next-pages/geo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/geo"])
      });
    }
  